import type { RefObject } from 'react';
import { useEffect } from 'react';

const useEscapeKeyHandler = (
  isModalVisible: boolean,
  closeRef: RefObject<HTMLButtonElement>
) => {
  useEffect(() => {
    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isModalVisible) {
        (closeRef.current as HTMLButtonElement).click();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isModalVisible, closeRef]);
};

export default useEscapeKeyHandler;
